import { jsx as _jsx } from "react/jsx-runtime";
import { DesignSystem } from '~/views/organisms/design.system';
import { PageWrapper } from '~/views/organisms/wrapper.page';
export const PageNotFound = () => {
    return (_jsx(PageWrapper, { p: 2, children: _jsx(DesignSystem, {}) }));
};
